
<div class="col-xs-12" *ngIf="labels.length">
  <div data-testid="order-label" class="label label-primary m-l-xs" *ngFor="let label of labels; let i = index;">{{label}}<i class="fa fa-trash-o m-l-xs m-r-xs pointer" (click)="removeItem(i)"></i></div><i class="fa fa-plus-square-o pointer m-l-xs" (click)="addLabel()"></i>
</div>